import ENV_VARS from '@/config'
import { get, post, put } from '@/ports/api'
const { BACKEND_SERVER } = ENV_VARS

export const login = post(`${BACKEND_SERVER}/auth/login`, {
  failSilently: true // Error handling in src/models/auth/index.js
})

export const requestAutoLogin = post(`${BACKEND_SERVER}/auth/login/auto`)

export const setInitialPassword = put(`${BACKEND_SERVER}/auth/password/initial`)

export const requestResetPassword = post(`${BACKEND_SERVER}/auth/password/autopass`)

export const changePassword = put(`${BACKEND_SERVER}/auth/password`, {
  failSilently: true
})

export const autoLogin = post(`${BACKEND_SERVER}/users/otp/%loginHash%`)

export const externalAutoLogin = get(`${BACKEND_SERVER}/auth/external/sign/%loginHash%`)

export const logout = post(`${BACKEND_SERVER}/users/logout`)

export const verifyUsername = post(`${BACKEND_SERVER}/users/verify/username`, {
  failSilently: true
})

export const registerRenter = post(`${BACKEND_SERVER}/users/renter`)

export const registerRenterSocial = post(`${BACKEND_SERVER}/social_login/%platform%/sign_up`)

export const tokenSessionValidate = post(`${BACKEND_SERVER}/users/mobile/auth/token/validate`, {
  failSilently: true,
  noLoading: true
})

export const tokenSession = post(`${BACKEND_SERVER}/users/mobile/auth/token/session`, {
  noLoading: true
})

export const getCountryByIP = get(`${BACKEND_SERVER}/lookup/country_code_by_ip`, {
  noLoading: true
})
